const STATISTICS_PERIODS = {
  MONTHLY: 'monthly',
  ANNUALLY: 'annually',
};

export { STATISTICS_PERIODS };
